import React, { useState } from "react";
import {
  Modal,
  Form,
  Input,
  DatePicker,
  Button,
  message,
  Alert,
  Divider,
} from "antd";
import { Api_Url } from "../../../config/config";

const { TextArea } = Input;

export const BranchIssueModalResolve = ({ issue, onClose, onSuccess }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const onFinish = async (values) => {
    setLoading(true);
    try {
      const payload = {
        Id: issue.id,
        Resolution: values.Resolution,
        // values.ResolutionDate is now checked by Form rules
        ResolutionDate: values.ResolutionDate.format("YYYY-MM-DD"),
        Remarks: values.Remarks || "",
      };

      const response = await fetch(`${Api_Url}api/v1/BranchIssue/${issue.id}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${
            JSON.parse(sessionStorage.getItem("user")).accessToken
          }`,
        },
        body: JSON.stringify(payload),
      });

      const result = await response.json();

      if (response.ok) {
        message.success("Issue marked as resolved");
        onSuccess();
      } else {
        throw new Error(result.message || "Failed to resolve issue");
      }
    } catch (error) {
      message.error(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title={
        <span style={{ fontSize: "18px", fontWeight: "bold" }}>
          Resolve Branch Issue #{issue.id}
        </span>
      }
      open={true}
      onCancel={onClose}
      footer={[
        <Button key="back" onClick={onClose}>
          Cancel
        </Button>,
        <Button
          key="submit"
          type="primary"
          loading={loading}
          onClick={() => form.submit()}
        >
          Confirm Resolution
        </Button>,
      ]}
      centered
      width={600}
    >
      <Alert
        message={`Reported Issue at ${issue.branchName}`}
        description={issue.issue}
        type="info"
        showIcon
        style={{ marginBottom: 20 }}
      />

      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        // FIX: Removed ResolutionDate from initialValues
        initialValues={{
          Remarks: issue.remarks,
        }}
      >
        <Form.Item
          name="ResolutionDate"
          label="Resolution Date"
          rules={[
            {
              required: true,
              message: "Please select the date this issue was resolved",
            },
          ]}
        >
          <DatePicker
            style={{ width: "100%" }}
            format="DD-MM-YYYY"
            placeholder="Select Resolution Date" // Added placeholder
          />
        </Form.Item>

        <Divider plain>Resolution Summary</Divider>

        <Form.Item
          name="Resolution"
          label="How was it resolved?"
          rules={[
            { required: true, message: "Please provide resolution details" },
            { min: 5, message: "Please be more descriptive" },
          ]}
        >
          <TextArea
            rows={4}
            placeholder="Describe the steps taken to fix the issue..."
          />
        </Form.Item>

        <Form.Item name="Remarks" label="Final Remarks / Closing Notes">
          <TextArea
            rows={2}
            placeholder="Any final thoughts or follow-ups..."
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};
